import ProgressLayout from "../../Layouts/Main/progress";
import { CreateModule } from "../factory";
import navigation from "./navigations";

const Grading = ({ baseUrl }) =>
  CreateModule({ baseUrl, navigation, layout: ProgressLayout });
export default Grading;
